import React, { useEffect } from "react";
import { Col, Container, Row } from "reactstrap";

// redux toolkit
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { fetchAgreements } from "../../slices/apps/agreementSlice";
import { fetchAgencies } from "../../slices/apps/agencySlices";

// hooks
import { useProfile } from "../../Components/Hooks/UserHooks";

// sayfalar, modallar vb.
import AgreementTable from "./AgreementTable";

const Agreements = () => {
  const dispatch = useDispatch();
  const { userProfile } = useProfile();

  const { agreementsRefresh } = useSelector((state) => {
    return {
      agreementsRefresh: state.agreement.agreementsRefresh,
    };
  }, shallowEqual);

  const fetchData = async () => {
    try {
      await dispatch(fetchAgreements());

      if (userProfile.data.Role == "SuperAdmin") {
        await dispatch(fetchAgencies());
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch, agreementsRefresh]);

  document.title = "Sözleşme Listesi | Global Yol Yardım";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xxl={12}>
              <AgreementTable />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Agreements;
